import { Delete as DeleteIcon } from '@mui/icons-material'
import { Grid, IconButton, Typography } from '@mui/material'
import { useCreditApplicationData } from '@src/contexts/CreditApplicationContext'
import { FieldError, FieldErrorsImpl, Merge, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InputTextField, SelectComponent } from '../../../components'
import { useCurrentLang, useJobTypeEnum } from '../../../data/selectors/app-config-selectors'
import { ApplicantIncomes, ApplicantJob, SelectValueListItem } from '../../../data/types'

interface Props {
  index: number
  register: UseFormRegister<ApplicantIncomes>
  error: Merge<FieldError, (Merge<FieldError, FieldErrorsImpl<ApplicantJob>> | undefined)[]> | undefined
  onDelete: () => void
}

const IncomeForm = ({ index, register, error, onDelete }: Props) => {
  const { t } = useTranslation()
  const { creditApplication } = useCreditApplicationData()
  const financingProgramId = creditApplication?.financingProgramId
  const jobTypeEnum = useJobTypeEnum(financingProgramId || null)
  const lang = useCurrentLang()

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid
        alignItems="center"
        alignContent="center"
        size={{
          xs: 12,
          md: 2,
        }}
      >
        <Typography variant="body1" component="div" sx={{ paddingTop: 2, paddingBottom: 2 }}>
          {`${t('editCreditApplication.income.job.job')} ${index + 1}`}:
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <InputTextField
          error={error?.[index]?.annualSalary}
          label={t('editCreditApplication.income.job.annualSalary')}
          {...register(`currentJobs.${index}.annualSalary`)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <SelectComponent
          error={error?.[index]?.jobType}
          items={Object.values(jobTypeEnum).map((item) => {
            const data: SelectValueListItem = { label: item[lang], value: item.id }
            return data
          })}
          label={t('editCreditApplication.income.job.jobType')}
          {...register(`currentJobs.${index}.jobType`)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <InputTextField
          error={error?.[index]?.employerName}
          label={t('editCreditApplication.income.job.employerName')}
          {...register(`currentJobs.${index}.employerName`)}
          maxLength={100}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 1,
        }}
      >
        <IconButton onClick={onDelete}>
          <DeleteIcon />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default IncomeForm
